import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../generic.service';
import { UpdateUserProfileRequest } from '../../models/account-centre/updateUserProfileRequest';
import { ParentsInformationRequest } from '../../models/parents-information/parentsInformationRequest';

@Injectable({ providedIn: 'root' })
export class SignupOnboardingService {
  private readonly genericService = inject(GenericService);


  updateDemography(payload: UpdateUserProfileRequest): Observable<any> {
    return this.genericService.put('user/updateprofile', payload);
  }


  createParentInfo(req: ParentsInformationRequest): Observable<any> {
    return this.genericService.post<any>('parentsinformation', req);
  }
}
